// AI types and shared utilities. See docs/05-combat-sim §5.6 and docs/04 §4.10
// for the canonical pipeline.
export const DEFAULT_RULES = {
    targeting: 'target_nearest',
    movement: 'move_distance_short',
    tempo: 'tempo_burst',
    threatPolicy: 'threat_neutral',
    positionPolicy: 'pos_behind_target',
};
/** Pull category-specific rules from an entity's BehaviorRule array. */
export function extractRules(entity) {
    const out = {
        targeting: null,
        movement: null,
        tempo: null,
        threatPolicy: null,
        positionPolicy: null,
        damageReacts: [],
    };
    const damageReacts = [];
    for (const rule of entity.behaviorRules) {
        switch (rule.category) {
            case 'targeting':
                out.targeting = rule.ruleId;
                break;
            case 'movement':
                out.movement = rule.ruleId;
                break;
            case 'tempo':
                out.tempo = rule.ruleId;
                break;
            case 'threatPolicy':
                out.threatPolicy = rule.ruleId;
                break;
            case 'positionPolicy':
                out.positionPolicy = rule.ruleId;
                break;
            case 'damageReact':
                damageReacts.push(rule.rule);
                break;
            // 'trigger' and 'startBuff' run on parallel axes and are not part of the
            // core dispatch order.
            case 'trigger':
            case 'startBuff':
                break;
        }
    }
    out.damageReacts = damageReacts;
    return out;
}
/** Vector helpers (kept tiny and inline-friendly). */
export function distance(a, b) {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
}
export function direction(from, to) {
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const len = Math.sqrt(dx * dx + dy * dy);
    if (len === 0)
        return { x: 0, y: 0 };
    return { x: dx / len, y: dy / len };
}
export function add(a, b) {
    return { x: a.x + b.x, y: a.y + b.y };
}
export function scale(v, s) {
    return { x: v.x * s, y: v.y * s };
}
//# sourceMappingURL=types.js.map